<template>
    <div class="ix-formbuilder-component-summary-content">
        <div class="formbuilder-component boxed" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div style="display:flex" class="formbuilder-component-content">
                <div class="formbuilder-component-left">
                    <label :for="index" class="formbuilder-component-label" v-bind:class="{'required' : currentField.required}">{{ currentField.label }}</label>
                    <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'readable'">
                    <span class="formbuilder-indications">Un seul choix possible</span>
                    <div class="formbuilder-option" v-for="(option,index) in currentField.options" :key="index">
                            <span class="formbuilder-checkbox round">
                                <span v-if="currentField.value == option.value" class="tick">&#10004;</span>
                        </span> 
                        {{ option.value }}
                    </div>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'fillable'" style="width: 100% !important">
                    <select class="form-control" v-model="currentField.value" :required="currentField.required" :name="index" :id="index">
                        <option value="">Sélectionner un élément</option>
                        <option v-for="(item,i) in currentField.options" :value="item.value" :key="i">{{ item.value }}</option>
                    </select>
                </div>

                <div class="clearfix"></div>
            </div>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Choix à sélection">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-list"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>{{ currentField.options.length }} option{{ currentField.options.length > 1 ? 's' : '' }}</li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "SelectComponent",
        props: ['currentField','showIcon','displayMode','index'],
        mounted() {
            if(this.displayMode == "readable"){
                this.currentField.value = this.currentField.value ? this.currentField.value : 'Non renseigné'
            }
        }
    }
</script>
